import { render, staticRenderFns } from "./DashboardSetupState.vue?vue&type=template&id=6b775e85&"
import script from "./DashboardSetupState.vue?vue&type=script&lang=js&"
export * from "./DashboardSetupState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports